module.exports = __webpack_public_path__ + "static/media/card-logo-6.8aca06a6.svg";